import axios from 'axios'

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN
});

axiosInstance.interceptors.request.use((config) => {
  const jwt = window.localStorage.getItem('jwt')
  if (jwt) config.headers['Authorization'] = `Bearer ${jwt}`;
  return config;
});

/**
 * @typedef {Object} loginRequestBody
 * @property {string} loginRequestBody.email
 * @property {string} loginRequestBody.password
 *
 * @typedef {Object} loginResponseBody
 * @property {string} loginResponseBody.jwt
 * @property {Object} loginResponseBody.user
 *
 * @param {loginRequestBody} loginRequestBody
 * @returns {loginResponseBody}
 */
export const loginRequest = async loginRequestBody => (await axiosInstance.post('/api/v1/auth/signin', loginRequestBody)).data;

/**
 *
 *
 * company crud section
 *
 *
 */
export const listAllCompaniesRequest = async () => (await axiosInstance.get('/api/v1/internal/company')).data;
/**
 * @typedef {Object} CreateCompanyRequestBody
 * @property {string} CreateCompanyRequestBody.name
 * @property {string[]} CreateCompanyRequestBody.businesses
 *
 * @typedef {Object} CreateCompanyResponseBody
 * @property {string} CreateCompanyResponseBody.id
 * @property {string} CreateCompanyResponseBody.name
 * @property {any[]} CreateCompanyResponseBody.businesses
 *
 * @param {CreateCompanyRequestBody} createCompanyRequestBody
 * @returns {CreateCompanyResponseBody}
 */
export const createCompanyRequest = async (createCompanyRequestBody) => (await axiosInstance.post('/api/v1/internal/company', createCompanyRequestBody)).data;

/**
 * @typedef {Object} EditCompanyRequestBody
 * @property {string} EditCompanyRequestBody.name
 *
 * @param {string} companyId
 * @param {EditCompanyRequestBody} editCompanyRequestBody
 * @returns
 */
export const editCpmpanyRequest = async (companyId, editCompanyRequestBody) => (await axiosInstance.patch(`/api/v1/internal/company/${companyId}`, editCompanyRequestBody)).data;

/**
 * @typedef {Object} CreateBusinessRequestBody
 * @property {string} CreateBusinessRequestBody.name
 *
 * @param {string} companyId
 * @param {CreateBusinessRequestBody} createBusinessRequestBody
 * @returns
 */
export const createBusinessRequest = async (companyId, createBusinessRequestBody) => (await axiosInstance.post(`/api/v1/internal/company/${companyId}/business`, createBusinessRequestBody)).data;

/**
 * @typedef {Object} EditBusinessRequestBody
 * @property {string} EditBusinessRequestBody.name
 *
 * @param {string} companyId
 * @param {string} businessId
 * @param {EditBusinessRequestBody} editBusinessRequestBody
 * @returns
 */
export const editBusinessRequest = async (companyId, businessId, editBusinessRequestBody) => (await axiosInstance.patch(`/api/v1/internal/company/${companyId}/business/${businessId}`, editBusinessRequestBody)).data;

/**
 *
 *
 * user crud section
 *
 *
 */

/**
 *
 * @returns {Promise<string[]>}
 */
export const listAllUiDisplyedGroupsRequest = async () => (await axiosInstance.get('/api/v1/iam/iam-group')).data;
export const listAllUsersRequest = async () => (await axiosInstance.get('/api/v1/internal/all_users')).data;
export const createUserRequest = async (companyId, requestBody) => (await axiosInstance.post(`/api/v1/company/${companyId}/users`, requestBody)).data;
export const editUserRequest = async (companyId, userId, requestBody) => (await axiosInstance.put(`/api/v1/company/${companyId}/user/${userId}`, requestBody)).data;


/**
 *
 *
 * device crud section
 *
 *
 */
export const listAllDevicesRequest = async () => (await axiosInstance.get('/api/v1/internal/all_calyxY_devices')).data;
export const createDeviceRequest = async (requestBody) => (await axiosInstance.post('/api/v1/internal/device', requestBody)).data;
export const unbindDeviceRequest = async (positionId, deviceId) => (await axiosInstance.delete(`/api/v1/position/${positionId}/device/${deviceId}/relation`)).data;
export const patchDeviceRequest = async (companyId, deviceId, requestBody) => (await axiosInstance.patch(`/api/v1/internal/company/${companyId}/device/${deviceId}`, requestBody)).data;
// 以下 API 目前後端尚不存在
export const putAdjustRequest = async (companyId, deviceId, requestBody) => (await axiosInstance.put(`/api/v1/internal/company/${companyId}/device/${deviceId}/adjust`, requestBody)).data;
export const putSensorPreferenceRequest = async (companyId, deviceId, requestBody) => (await axiosInstance.put(`/api/v1/internal/company/${companyId}/device/${deviceId}/sensor-preference`, requestBody)).data;
export const putDefaultSensorPreferenceRequest = async (companyId, deviceId) => (await axiosInstance.put(`/api/v1/internal/company/${companyId}/device/${deviceId}/default-sensor-preference`)).data;
export const putProbeTypeRequest = async (companyId, deviceId, requestBody) => (await axiosInstance.put(`/api/v1/internal/company/${companyId}/device/${deviceId}/probe-type`, requestBody)).data;


/**
 *
 *
 * scale crud section
 *
 *
 */
export const listAllScalesRequest = async () => (await axiosInstance.get('/api/v1/internal/smart-scales')).data;
/** @deprecated 後端已刪除(ai-eye rework 退場,打了是 404)——磅秤建檔改在 dataOps lab 做 */
export const createScaleRequest = async (requestBody) => (await axiosInstance.post('/api/v1/internal/smart-scale', requestBody)).data;
// 先不做，因為若該house還有cycle在跑可能會出錯，未來有需要再將解綁功能打開
// export const unbindScaleRequest = async (houseId ,scaleId) => (await axiosInstance.delete(`/api/v1/house/${houseId}/scale-device/${scaleId}/relation`)).data;
/** @deprecated 後端已刪除(ai-eye rework 退場,打了是 404)——相機參數等磅秤編輯改在 dataOps lab 做 */
export const updateScaleRequest = async ({ deviceId, requestBody, historyTime }) => (await axiosInstance.patch(
  `/api/v1/internal/smart-scale/${deviceId}`,
  requestBody,
  {
    params: {
      historyTime,
    },
  },
)).data;
/** @deprecated 後端已刪除(ai-eye rework 退場,打了是 404)——磅秤換舍改在 dataOps lab 做 */
export const patchScaleRequest = async (houseId, scaleSerialNumber, requestBody) => (await axiosInstance.patch(`/api/v1/house/${houseId}/smart-scale/${scaleSerialNumber}/relation`, requestBody)).data;
export const getScaleBySerialNumberRequest = async ({ serialNumber }) => {
  return await axiosInstance.get(
    '/api/v1/internal/smart-scales',
    {
      params: {
        serialNumber,
      },
    }
  )
    .then((res) => {
      if (res.data.length > 1) {
        throw new Error('Result scale is not unique.');
      }

      if (res.data.length === 0) return null;

      if (res.data[0].serialNumber !== serialNumber) {
        throw new Error('Result scale Serial Number mismatched.');
      }

      return res.data[0];
    })
}
/** @deprecated 後端已刪除(ai-eye rework 退場,打了是 404)——undistortion matrix 上傳改在 dataOps lab 做 */
export const uploadScaleUndistortionFileRequest = async ({ deviceId, file }) => {
  const formData = new FormData();

  formData.set('file', file);

  return await axiosInstance.patch(
    `/api/v1/internal/smart-scale/${deviceId}/undistortion-matrix-file`,
    formData,
  )
    .then((res) => res.data)
}
export const publishAIEyeDownlinkRequest = async ({ serialNumber, payload, timeout }) => {
  return await axiosInstance.post(
    `/api/v1/internal/smart-scale/downlink`,
    {
      serialNumber,
      payload,
      timeout,
    }
  )
    .then((res) => res.data)
}
export const queueYDeviceDownlinkRequest = async ({ serialNumber, payload }) => {
  return await axiosInstance.post(
    `/api/v1/internal/y-device/downlink`,
    {
      serialNumber,
      payload,
    }
  )
    .then((res) => res.data)
}
export const listAllLatestAIEyeStatusDataRequest = async () => {
  return await axiosInstance.get('/api/v1/internal/all-latest-ai-eye-status-data')
    .then((res) => res.data)
}
export const listAllLatestLoadCellWeightDataRequest = async () => {
  return await axiosInstance.get('/api/v1/internal/all-latest-loadcell-weight-data')
    .then((res) => res.data)
}
export const listAllLatestAIEyeImageCatalogRequest = async () => {
  return await axiosInstance.get('/api/v1/internal/all-latest-ai-eye-image-catalog')
    .then((res) => res.data)
}
export const listAllRecentLoadCellWeightSummaryRequest = async () => {
  return await axiosInstance.get('/api/v1/internal/all-recent-loadcell-weight-summary')
    .then((res) => res.data)
}
export const listAllTailscaleStatusRequest = async () => {
  return await axiosInstance.get('/api/v1/internal/all-tailscale-status')
    .then((res) => res.data)
}
export const getLatestUndistortedAIEyeImage = async ({ houseId, serialNumber }) => {
  return await axiosInstance.get(`/api/v1/house/${houseId}/scale/${serialNumber}/latest-undistorted-image`, {
    responseType: 'blob'
  })
    .then((res) => ({
      blob: res.data,
      timestamp: res.headers['calyx-image-timestamp'] != null ? new Date(res.headers['calyx-image-timestamp']) : null,
    }))
}

/**
 *
 *
 * e-controller crud section
 *
 *
 */
export const listAllEControllersRequest = async () => (await axiosInstance.get('/api/v1/internal/e-controllers')).data;
export const createEControllerRequest = async (requestBody) => (await axiosInstance.post('/api/v1/internal/e-controllers', requestBody)).data;
export const editEControllerRequest = async (originalCompanyId, eControllerId, requestBody) => (await axiosInstance.patch(`/api/v1/internal/company/${originalCompanyId}/e-controllers/${eControllerId}`, requestBody)).data;
export const unbindEControllerRequest = async (companyId, hosueId, eControllerId) => (await axiosInstance.delete(`/api/v1/company/${companyId}/house/${hosueId}/e-controllers/${eControllerId}/relation`)).data;

export const listAllAnimalBreedRequest = async () => (await axiosInstance.get(`/api/v1/all-animal-breeds`)).data;

/**
 *
 *
 * water meter crud section
 *
 *
 */
export const createWaterMeterRequest = async (waterMeter) => (await axiosInstance.post('/api/v1/internal/water-meter', waterMeter)).data;
export const listAllWaterMeterRequest = async () => (await axiosInstance.get('/api/v1/internal/water-meters')).data;
export const bindWaterMeterRequest = async (deviceId, houseId) => (await axiosInstance.put(`/api/v1/internal/water-meter/${deviceId}/relation`, { houseId })).data;
export const unbindWaterMeterRequest = async (deviceId) => (await axiosInstance.delete(`/api/v1/internal/water-meter/${deviceId}/relation`)).data;
export const listAllLatestWaterMeterSensingDataRequest = async () => (await axiosInstance.get('/api/v1/internal/all-latest-water-meter-sensing-data')).data;


/* Products API */

/** @import { CreateProductReqBodyDto, PatchProductReqBodyDto, ProductResBodyDto } from './hey-api'; */

/** @type {(product: CreateProductReqBodyDto) => Promise<ProductResBodyDto>} */
export const createProductRequest = async (product) => await axiosInstance.post('/api/v1/internal/products', product).then((res) => res.data);
/** @type {() => Promise<ProductResBodyDto[]>} */
export const listProductsRequest = async () => await axiosInstance.get('/api/v1/internal/products').then((res) => res.data);
/** @type {(productId: string) => Promise<ProductResBodyDto>} */
export const getProductRequest = async (productId) => await axiosInstance.get(`/api/v1/internal/products/${productId}`).then((res) => res.data);
/** @type {(productId: string, product: PatchProductReqBodyDto) => Promise<ProductResBodyDto>} */
export const patchProductRequest = async (productId, product) => await axiosInstance.patch(`/api/v1/internal/products/${productId}`, product).then((res) => res.data);
/** @type {(productId: string) => Promise<void>} */
export const deleteProductRequest = async (productId) => await axiosInstance.delete(`/api/v1/internal/products/${productId}`).then((res) => res.data);


/* Contracts API */

/** @import { CreateContractReqBodyDto, PatchContractReqBodyDto, ContractResBodyDto } from './hey-api'; */

/** @type {(contract: CreateContractReqBodyDto) => Promise<ContractResBodyDto>} */
export const createContractRequest = async (contract) => await axiosInstance.post('/api/v1/internal/contracts', contract).then((res) => res.data);
/** @type {() => Promise<ContractResBodyDto[]>} */
export const listContractsRequest = async () => await axiosInstance.get('/api/v1/internal/contracts').then((res) => res.data);
/** @type {(contractId: string) => Promise<ContractResBodyDto>} */
export const getContractRequest = async (contractId) => await axiosInstance.get(`/api/v1/internal/contracts/${contractId}`).then((res) => res.data);
/** @type {(contractId: string, contract: PatchContractReqBodyDto) => Promise<ContractResBodyDto>} */
export const patchContractRequest = async (contractId, contract) => await axiosInstance.patch(`/api/v1/internal/contracts/${contractId}`, contract).then((res) => res.data);
/** @type {(contractId: string) => Promise<void>} */
export const deleteContractRequest = async (contractId) => await axiosInstance.delete(`/api/v1/internal/contracts/${contractId}`).then((res) => res.data);
